import useSWR from 'swr';
import api from '../../services/api';
import { APP_CONFIG } from '../../config/appConfig';
import type { AiChatConversation, AiChatConversationDetail, AiChatMessage } from './types';

const CONVERSATIONS_KEY = '/ai/chat/conversations';

export function useAiChatConversations(enabled: boolean) {
  return useSWR<{ conversations: AiChatConversation[] }>(
    enabled ? CONVERSATIONS_KEY : null,
    (url: string) => api.get(url).then((r) => r.data),
  );
}

export function conversationMessagesKey(conversationId: number | null) {
  return conversationId ? `/ai/chat/conversations/${conversationId}/messages` : null;
}

export function useAiChatMessages(conversationId: number | null, enabled: boolean) {
  return useSWR<{
    conversation: AiChatConversationDetail;
    messages: AiChatMessage[];
  }>(
    enabled && conversationId ? conversationMessagesKey(conversationId) : null,
    (url: string) => api.get(url).then((r) => r.data),
  );
}

export async function createAiConversation(modelId?: string): Promise<AiChatConversation> {
  const { data } = await api.post<{ conversation: AiChatConversation }>('/ai/chat/conversations', {
    modelId: modelId || undefined,
  });
  return data.conversation;
}

export async function deleteAiConversation(conversationId: number): Promise<void> {
  await api.delete(`/ai/chat/conversations/${conversationId}`);
}

export async function sendAiChatMessage(
  conversationId: number,
  content: string,
  model?: string,
): Promise<{ message: AiChatMessage }> {
  const { data } = await api.post<{ message: AiChatMessage }>(
    `/ai/chat/conversations/${conversationId}/messages`,
    { content, model },
    { timeout: APP_CONFIG.api.aiAssistantTimeout },
  );
  return data;
}

export { CONVERSATIONS_KEY };
